<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0 ;  height: 100%">
        <van-empty description="没有项目信息" v-show="row.subject_list.length==0" />
        <van-cell-group>
            <van-cell @click="jump(subject)" v-for="(subject,index) in row.subject_list"  :key="index" :title="'项目'+(index+1)"

                       >
                <template #right-icon>
                    <div > 
                        <div class="tiny-btn-1" v-if="subject.jizan_count==0">上传集赞数据</div>
                        <div class="tiny-btn-0" v-else>集赞数据已上传</div>
                    </div> 
                </template>

                <template #label>
                    <div>{{subject.subject_name}}</div>
                    <div>
                        运动员:
                        <span  style="color: #111" v-for="(member,index) in subject.yundongyuan" :key="index">{{member.name}} </span>
                    </div>
                </template>

            </van-cell>

        </van-cell-group>



    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }


    .bottom-button{
        margin-top: 0.2rem;
        margin-bottom: 0.2rem;
        width: 100%;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        margin-right: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'StationApply',
        components: {
            PicUploader,
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                row:{
                    danwei:{

                    },
                    subject_list:[

                    ],
                    _saiqu:{

                    }
                },
                formData: {

                },
            }
        },
        filters: {},
        mounted() {

            document.title = '申报列表';
            let that = this;
            that.row.id = this.$route.query.id;
            this.fetch();

            window.rbMessage = function (data) {
                console.log('zanlist 收到 '+data)
                if (data == 'saiApplyVideoReload') {
                    that.fetch();
                }
            }

        },
        watch: {
        },
        destroyed() {
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            jump(subject){
                rbLink(
                    {name:'ZSaiApplyFormUploadZan' ,query:{ id: subject.id }}
                )
            },
            fetch(){
                let that = this;
                that.$api.post('/api/isai/videolist', {
                    id:that.row.id
                }, (res) => {
                    that.row = res.data;
                }, (res) => {
                    Toast.fail(res.msg);
                })
            },

        }
    }
</script>



// WEBPACK FOOTER //
// SaiApplyZanList.vue?e7a086b2